import { createBrowserHistory } from 'history'
import { store } from '../store'
import { clearMessage } from '../store/modules/message/action';

const history = createBrowserHistory();

history.listen((location, action) => store.dispatch(clearMessage()));

export default history;